import { defineStore } from 'pinia'

let nextId = 0;

export const useAlertsStore = defineStore({
  id: 'alerts',
  state: () => ({
    alerts: []
  }),
  getters: {
    all: (state) => state.alerts,
  },
  actions: {
    add(type, message, selfDismiss = true) {
      let alert = {
        id: nextId++,
        type,
        message
      }
      this.alerts.push(alert)
      if(selfDismiss) {
        setTimeout(() => {
          this.close(alert.id)
        }, 5000)
      }
    },
    close(id) {
      this.alerts = this.alerts.filter((a) => a.id !== id)
    }
  }
})
